import { render, staticRenderFns } from "./SendTreeTicketForm.vue?vue&type=template&id=72bd8fd8&scoped=true"
import script from "./SendTreeTicketForm.vue?vue&type=script&lang=ts"
export * from "./SendTreeTicketForm.vue?vue&type=script&lang=ts"
import style0 from "./SendTreeTicketForm.vue?vue&type=style&index=0&id=72bd8fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd8fd8",
  null
  
)

export default component.exports